import i18n from '@/i18n'

i18n.mergeLocaleMessage('en', {
	'preloading' : {
        'name': 'Preloading',
        'set_up_preloading': 'Set up preloading',
        'learn_more': 'Learn more',
        'title': 'Stay one step ahead of your customers',
        'start_description': 'Preloading predicts which page customers will go to next and download its content in advance.',
        'description': 'Predict customers’ next page and download its content in advance.',
        'article': 'article about preloading',
        'use_preloading': 'Use Preloading',
        'select_preloading': 'Select preloading method',
        'simple_preloading': 'Simple Preloading',
        'smart_preloading': 'Smart Preloading',
        'mouse_position': 'Predict based on mouse position.',
        'page_data': 'Predict based on page data and mouse position.',
        'connected_ga': 'Google Analytics Profile Connected',
        'menstore': 'Menstore',
        'last_updated': 'Last updated: ',
        'page_will_updated': 'Page data will be updated from Google Analytics every 7 days.',
        'disconnect': 'Disconnect',
        'data_synced': 'Data successfully synced from Google Analytics',
        'disconnect_ga': 'Disconnect Google Analytics profile?',
        'use_smart_preloading': 'You won’t be able to use Smart Preloading once Google Analytics profile is disconnected.',
        'profile_title': 'Connect Google Analytics Profile',
        'profile_description': 'Select the Google Analytics profile for',
        'use_another_account': 'Use another account',
        'faster': '3x faster',
        'preloading_running': '<strong>Preloading</strong> is running on your store',
        'components': {
            'watch_demo': 'Watch demo video',
            'start_title_available': "Predict customer’s next move",
            'start_title_unavailable': "Predict customer’s next move with Premium Plan",
            'start_description_available': 'Load your store faster to increase customer experience.',
            'start_description_unavailable': 'Preloading is not available in your current plan, upgrade now to get it!',
            'tutorial_note': 'Popular technique used by',
        },
        'smart_tooltip': {
            'title': 'Your store is even faster',
            'description': 'Smart Preloading helps your store load faster <strong>900ms</strong> than without Preloading.'
        },
        'buttons': {
            'connect_ga': 'Connect Google Analytics',
            'sync_data': 'Sync data',
            'disconnect': 'Disconnect',
            'select_another_account': 'Select another account',
            'contact_customer_support': 'Contact Customer Support',
            'start_preloading': 'Start preloading now',
            'i_got_it': 'I got it',
            'watch_example_video': 'Watch example video'
        },
        'errors': {
            'please_connect_ga': 'Please connect Google Analytics profile to use Smart Preloading.',
            'no_ga_found': 'No Google Analytics profile found for this Google account',
            'error': 'Error',
            'error_id': 'Error ID',
            'profile_not_match': 'The selected profile doesn’t match your store. Please select another profile.',
            'permission_error': 'Your Google account doesn’t have full permission for this Google Analytics profile',
            'copy_error': "Please copy the error ID and send to our Customer Support team for help. We're sorry for any inconveniences."
        }
	}
})